export function filterNonEmpty<T>(item: T): item is NonNullable<T> {
	return typeof item !== 'undefined' && item !== null
}
